/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Address } from '../models/address';
import { GetManyAddressResponseDto } from '../models/get-many-address-response-dto';
import { getManyBaseMgmtCustomerAddressControllerAddress } from '../fn/address/get-many-base-mgmt-customer-address-controller-address';
import { GetManyBaseMgmtCustomerAddressControllerAddress$Params } from '../fn/address/get-many-base-mgmt-customer-address-controller-address';
import { getOneBaseMgmtCustomerAddressControllerAddress } from '../fn/address/get-one-base-mgmt-customer-address-controller-address';
import { GetOneBaseMgmtCustomerAddressControllerAddress$Params } from '../fn/address/get-one-base-mgmt-customer-address-controller-address';

@Injectable({ providedIn: 'root' })
export class AddressApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtCustomerAddressControllerAddress()` */
  static readonly GetManyBaseMgmtCustomerAddressControllerAddressPath = '/api/mgmt-customers/{customerId}/addresses';

  /**
   * Retrieve multiple Addresses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtCustomerAddressControllerAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCustomerAddressControllerAddress$Response(params: GetManyBaseMgmtCustomerAddressControllerAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyAddressResponseDto>> {
    const obs = getManyBaseMgmtCustomerAddressControllerAddress(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Addresses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtCustomerAddressControllerAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtCustomerAddressControllerAddress(params: GetManyBaseMgmtCustomerAddressControllerAddress$Params, context?: HttpContext): Observable<GetManyAddressResponseDto> {
    const resp = this.getManyBaseMgmtCustomerAddressControllerAddress$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyAddressResponseDto>): GetManyAddressResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtCustomerAddressControllerAddress()` */
  static readonly GetOneBaseMgmtCustomerAddressControllerAddressPath = '/api/mgmt-customers/{customerId}/addresses/{id}';

  /**
   * Retrieve a single Address.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtCustomerAddressControllerAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCustomerAddressControllerAddress$Response(params: GetOneBaseMgmtCustomerAddressControllerAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Address>> {
    const obs = getOneBaseMgmtCustomerAddressControllerAddress(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Address.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtCustomerAddressControllerAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtCustomerAddressControllerAddress(params: GetOneBaseMgmtCustomerAddressControllerAddress$Params, context?: HttpContext): Observable<Address> {
    const resp = this.getOneBaseMgmtCustomerAddressControllerAddress$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Address>): Address => r.body)
    );
  }

}
